export const COMPANY_NAME = "ROCKETBOSS LLC";
export const COMPANY_SHORT = "RocketBoss LLC";
export const COMPANY_INITIALS = "RB";
export const COMPANY_ADDRESS_FULL = "2027 MARIAH DR, SANTA MARIA, CA 93454";
export const COMPANY_LOCATION = "Santa Maria, CA";
export const COMPANY_REGION = "California";
export const FILED_DATE = "May 17, 2025";
export const ENTITY_TYPE = "California Limited Liability Company";
export const FILE_NUMBER = "B20250125124";
export const MANAGEMENT_STRUCTURE = "One Manager";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=2027%20MARIAH%20DR%2C%20SANTA%20MARIA%2C%20CA%2093454";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1517976487492-5750f3195933?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Entity", "value": ENTITY_TYPE },
  { "label": "Filed", "value": FILED_DATE },
  { "label": "Office", "value": COMPANY_LOCATION },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": COMPANY_NAME },
  { "label": "File Number", "value": FILE_NUMBER },
  { "label": "Management", "value": MANAGEMENT_STRUCTURE },
  { "label": "Principal Office", "value": COMPANY_ADDRESS_FULL },
];

export const CARE_PILLARS = [
  { "code": "01", "title": "Lawful Business Scope", "body": "The filing states the company may engage in any lawful act or activity available to a California LLC." },
  { "code": "02", "title": "California Formation", "body": "RocketBoss LLC is presented from its California Articles of Organization filing dated May 17, 2025." },
  { "code": "03", "title": "Single Management Line", "body": "The public record lists the management structure as one manager, keeping the company profile direct and simple." },
  { "code": "04", "title": "Public Record Profile", "body": "The page highlights only directory-safe formation details, address information, and broad company purpose." },
];
